import { RTKQueryTag } from 'src/common/constants';
import type { ApiResponse } from 'src/common/interfaces';
import { apiSlice } from 'src/features/api/api-slice';

export interface CddUser {
  id: string;
  username: string;
  email: string;
  roles: string[];
}

export interface TransformedCddUser {
  id: string;
  name: string;
  email: string;
  roles: string;
}

export interface AddCddAccessRequest {
  identifier: string;
  type: 'internal' | 'external';
}

export interface GeneratePemResponse {
  pemContent: string;
}

export const cddAccessApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getInternalUsers: builder.query<ApiResponse<CddUser[]>, void>({
      query: () => ({
        url: 'admin/users/content-devs',
        method: 'GET',
        params: {
          type: 'internal',
        },
      }),
      providesTags: [RTKQueryTag.CddAccess],
    }),
    getExternalUsers: builder.query<ApiResponse<CddUser[]>, void>({
      query: () => ({
        url: 'admin/users/content-devs',
        method: 'GET',
        params: {
          type: 'external',
        },
      }),
      providesTags: [RTKQueryTag.CddAccess],
    }),
    addCddAccess: builder.mutation<ApiResponse<void>, AddCddAccessRequest>({
      query: (body) => ({
        url: 'admin/users/content-devs',
        method: 'POST',
        body,
      }),
      invalidatesTags: [RTKQueryTag.CddAccess],
    }),
    removeCddAccess: builder.mutation<ApiResponse<void>, { identifier: string }>({
      query: (body) => ({
        url: 'admin/users/content-devs',
        method: 'DELETE',
        body,
      }),
      invalidatesTags: [RTKQueryTag.CddAccess],
    }),
    generatePem: builder.mutation<ApiResponse<GeneratePemResponse>, { identifier: string }>({
      query: ({ identifier }) => ({
        url: 'admin/users/content-devs/generate-pem',
        method: 'POST',
        body: { identifier },
      }),
    }),
  }),
});

export const {
  useGetInternalUsersQuery,
  useGetExternalUsersQuery,
  useAddCddAccessMutation,
  useRemoveCddAccessMutation,
  useGeneratePemMutation,
} = cddAccessApiSlice;
